import { render, staticRenderFns } from "./InvoiceAlert.vue?vue&type=template&id=522d102a&"
import script from "./InvoiceAlert.vue?vue&type=script&lang=js&"
export * from "./InvoiceAlert.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAlert.vue?vue&type=style&index=0&id=522d102a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports